const Header = () => {
    return (
        <header className="">
        </header>
    );
}

export default Header;